// OAuth 独立路由体系
// 与主站路由隔离，访问时不展示主站 header（见 App.vue）
const oauthRoutes = {
  path: "/oauth",
  name: "oauth",
  component: () => import("@/views/oauth/index.vue"),
  redirect: "/oauth/login",
  children: [
    {
      path: "login",
      name: "oauthLogin",
      component: () => import("@/views/oauth/login/index.vue"),
      meta: { requiresAuth: false }, // 登录页不需要验证
    },
    {
      path: "authorize",
      name: "oauthAuthorize",
      component: () => import("@/views/oauth/authorize/index.vue"),
      meta: { requiresAuth: true }, // 授权页需要登录态，未登录由 guard 跳回 /oauth/login
    },
  ],
};

export default oauthRoutes;
